import React, { forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Camera, OpStatus } from 'NSwag/ServerClient/Client.nswag';
import { Typography } from '@material-ui/core';
import NotAvailable from "Resources/Images/CctvIcons/NotAvailable.png";
import {getOpStatusDescription} from 'Util/OpStatusUtils';

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: '#ffffff',
        padding: theme.spacing(2),
        borderRadius: 5
    },
    streamContainer: {
        maxWidth: 100,
        maxHeight: 100
    }
}));

interface IProps {
    camera: Camera;
}

const CctvCameraTooltip = ({ camera }: IProps) => {

    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Typography variant="body1">
                {camera.config!.displayName}
            </Typography>
            <Typography variant="body2">
                Status: {getOpStatusDescription(camera.status!.opStatus)}
            </Typography>
        </div>
    );
};

export default CctvCameraTooltip;